/* eslint-disable @typescript-eslint/naming-convention */
// reference on smartystreets documentation page: https://www.smarty.com/docs/cloud/us-street-api#footnotes
export const SMARTY_FOOTNOTES: Record<string, string> = {
  "A#": "Corrected ZIP Code",
  "B#": "Fixed city/state spelling",
  "C#": "Invalid city/ state/ZIP",
  "D#": "No ZIP+4 assigned",
  "E#": "Same ZIP for multiple",
  "F#": "Address not found",
  "G#": "Used firm data",
  "H#": "Missing secondary number",
  "I#": "Insufficient/ incorrect address data",
  "J#": "Dual address",
  "K#": "Cardinal rule match",
  "L#": "Changed address component",
  "LI#": "Flagged address for LACSLink",
  "LL#": "Flagged address for LACSLink",
  "M#": "Fixed street spelling",
  "N#": "Fixed abbreviations",
  "O#": "Multiple ZIP+4; lowest used",
  "P#": "Better address exists",
  "Q#": "Unique ZIP match",
  "R#": "No match; EWS: Match soon",
  "S#": "Bad secondary address",
  "T#": "Multiple response due to magnet street syndrome",
  "U#": "Unofficial city name",
  "V#": "Unverifiable city/state",
  "W#": "Invalid delivery address",
  "X#": "Unique ZIP Code",
  "Y#": "Military match	",
  "Z#": "Matched with ZIPMOVE"
};
